<template>
  <div data-module="contact-form" :data-status="formStatus">
    <div class="module-layout">

      <span class="contact-form__anchor" id="contact-us-form" />

      <component_bigHeading :data="{heading: 'Drop us a line.'}" />

      <div class="form-container">
        <form v-on:submit.prevent="submitForm" v-show="formStatus=='default'">

          <div data-field="contact__name" class="contact-form__input" :class="{ 'has-input': hasInput(name) }">
            <label for="contact__name">Name</label>
            <input name="contact__name" id="contact__name" required type="text" v-model="name">
          </div>

          <div data-field="contact__company" class="contact-form__input" :class="{ 'has-input': hasInput(company) }">
            <label for="contact__company">Company</label>
            <input name="contact__company" id="contact__company" type="text" v-model="company">
          </div>

          <div data-field="contact__email" class="contact-form__input" :class="{ 'has-input': hasInput(email) }">
            <label for="contact__email">Email</label>
            <input name="contact__email" id="contact__email" required type="email" v-model="email">
          </div>

          <div data-field="contact__message" class="contact-form__textarea" :class="{ 'has-input': hasInput(message) }">
            <textarea name="contact__message" id="contact__message" v-model="message" placeholder="The message"></textarea>
          </div>

          <div class="contact-form__submit">
            <button :disabled="submitting">
              <span data-ornament="arrow--right" />
            </button>
          </div>

        </form>

        <div class="form-post-response form-post--success">
          <div class="form-post__success-indicator" v-show="formStatus=='success'">
            <p>Thank you for contacting Particle! We’ll do our best to get back to you in a timely manner, but please understand if we may not be able to respond to all inquiries. We look forward to learning more about you!</p>
          </div>
        </div>

        <div class="form-post-response form-post--error" v-show="formStatus=='error'">
          <p>There was an error! Please email us at <a :href="`mailto:${contactEmail}`">{{contactEmail}}</a></p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// Libs
import axios from 'axios';

// Constants / Data
import { email } from '@/data/snippets/companyInfo';

function encode(data) {
  return Object.keys(data)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join('&');
}

// Module expects:
export default {

  name: 'contact-form',

  props: ['data'],

  data() {
    return {
      name: null,
      company: null,
      email: null,
      message: null,
      submitting: false,
      formStatus: 'default',
      contactEmail: email,
    };
  },

  methods: {

    hasInput(el) {
      if (el && el.trim().length > 0) {
        return true;
      }
      return false;
    },

    packageFormData() {
      return {
        name: this.name,
        company: this.company,
        email: this.email,
        message: this.message,
      };
    },

    handleOkResponse(response) {
      switch (response.status) {
        case 200:
          // show a way cool notification
          this.formStatus = 'success';
          break;
        default:
          // show a cool, but not as cool notification here
          // console.log('shrug emoticon');
          this.formStatus = 'error';
          this.submitting = false;
          break;
      }
    },

    handleErrorResponse(err) {
      // handle some errors here
      switch (err) {
        default:
          this.formStatus = 'error';
          break;
      }
    },

    submitForm() {
      // stop double submit
      this.submitting = true;

      const url = `${window.location.origin}`;
      const formData = this.packageFormData();
      const data = encode({
        'form-name': 'contact', // for Netlify
        ...formData,
      });
      axios({
        url,
        method: 'post',
        data,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      })
        .then(response => this.handleOkResponse(response))
        .catch(err => this.handleErrorResponse(err));
    },

  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';
@import '~@/styles/_grid.scss';

[data-module="contact-form"] {
  width: 100%;

  // media query props
  margin-bottom: rem($layout--default-module-spacing-mobile);

  @include ngMq($nbp--tablet, up) {
    margin-bottom: rem($layout--default-module-spacing-tablet);
  }

  @include ngMq($nbp--desktop, up) {
    margin-bottom: rem($layout--default-module-spacing-desktop);
  }

  .module-layout {
    // media query props
    @include ngGrid('mobile');

    @include ngMq($nbp--tablet, up) {
      @include ngGrid('tablet');
    }
    @include ngMq($nbp--desktop, up) {
      @include ngGrid('desktop');
    }

    .contact-form__anchor {
      position: absolute;

      // media query props
      top: rem(-100px);

      // @include ngMq($nbp--tablet, up) {
      //   top: rem(-100px);
      // }
      @include ngMq($nbp--desktop, up) {
        top: rem(-200px);
      }
    }

    [data-component="bigHeading"] {
      grid-row: 1 / span 1;

      // media query props
      grid-column: 1 / span 6;

      @include ngMq($nbp--tablet, up) {
        grid-column: 1 / span 12;
      }
      // @include ngMq($nbp--desktop, up) {
      //   grid-column: 9 / span 2;
      // }
    }

    .form-container {
      grid-row: 2 / span 1;

      // media query props
      grid-column: 1 / span 6;

      @include ngMq($nbp--tablet, up) {
        grid-column: 1 / span 12;
      }
      // @include ngMq($nbp--desktop, up) {
      //   grid-column: 9 / span 2;
      // }


      /*
        Form element designs
      */

      .contact-form__submit {
        pointer-events: none;

        display: flex;
        align-items: center;
        justify-content: flex-end;

        // media query props
        margin-top: rem(-30px);

        @include ngMq($nbp--tablet, up) {
          margin-top: rem(-30px);
        }
        @include ngMq($nbp--desktop, up) {
          margin-top: rem(-50px);
        }

        button {
          border-radius: 50%;
          background: black;
          border: 0;
          color: #fff;
          cursor: pointer;
          pointer-events: auto;

          // media query props
          width: rem(60px);
          height: rem(60px);
          margin-right: $grid-column-mobile * 1px;

          @include ngMq($nbp--tablet, up) {
            width: rem(60px);
            height: rem(60px);
            margin-right: $grid-column-tablet * 1px;
          }
          @include ngMq($nbp--desktop, up) {
            width: rem(100px);
            height: rem(100px);
            margin-right: $grid-column-desktop * 1px;
          }
        }

        [data-ornament] {
          display: inline-block;

          // media query props
          width: rem(16px);

          @include ngMq($nbp--tablet, up) {
            width: rem(16px);
          }
          @include ngMq($nbp--desktop, up) {
            width: rem(26px);
          }
        }
      }

      .contact-form__textarea {
        textarea {
          display: block;
          width: 100%;
          height: 100%;

          border: 0;
          border: 1px solid black;
          border-radius: 0;
          padding: rem(22px);
          resize: none;

          // media query props
          @include sansserif( $size: (16, 16, 0));

          // tablet & desktop
          @include ngMq($nbp--tablet, up) {
            @include sansserif( $size: (18, 18, 0));
          }

          &::placeholder {
            color: #B3B3B3;
            opacity: 1;

            // media query props
            @include sansserif( $size: (16, 16, 0), $weight: 'light');

            // tablet & desktop
            @include ngMq($nbp--tablet, up) {
              @include sansserif( $size: (18, 18, 0), $weight: 'light');
            }

          }
        }
      }

      .contact-form__input {
        label {
          position: absolute;
          left: 0;

          color: #B3B3B3;
          padding: 0 rem(22px);
          z-index: 1;

          pointer-events: none;
          transition: all 150ms;

          // media query props
          top: rem((60px - 16px) / 2);
          @include sansserif( $size: (16, 16, 0), $weight: 'light');

          // tablet & desktop
          @include ngMq($nbp--tablet, up) {
            top: rem((90px - 18px) / 2);
            @include sansserif( $size: (18, 18, 0), $weight: 'light');
          }
        }

        &.has-input {
          label {
            top: 0;

            // media query props
            font-size: rem(9px);
            transform: translateY(calc((((60px - 16px) / 2) - 9px + 4px) / 2));

            // tablet & desktop
            @include ngMq($nbp--tablet, up) {
              font-size: rem(11px);
              transform: translateY(calc((((90px - 18px) / 2) - 11px + 4px) / 2));
            }
          }
        }

        input {
          display: block;
          width: 100%;
          border: 1px solid black;
          padding: 0 rem(22px);

          // media query props
          height: rem(60px);
          @include sansserif( $size: (16, 16, 0));

          @include ngMq($nbp--tablet, up) {
            height: rem(90px);
            @include sansserif( $size: (18, 18, 0));
          }

          &::placeholder {
            color: #ff0003;
            opacity: 1;
          }
        }
      }

      /*
        form core layout
      */

      form {

        @include createGrid(6, 0, 0);
        grid-template-rows: repeat(5, auto);

        @include ngMq($nbp--tablet, up) {
          @include createGrid(12, 0, 0);
          grid-template-rows: repeat(3, auto);
          font-size: rem(18px);
        }

        .contact-form__submit {
          grid-row: 5 / span 1;

          // media query props
          grid-column: 5 / span 2;

          @include ngMq($nbp--tablet, up) {
            grid-column: 11 / span 2;
          }
          @include ngMq($nbp--desktop, up) {
            grid-column: 10 / span 3;
          }
        }

        .contact-form__input {
          input {
            border-radius: 0;
            border-bottom: 0;
          }
        }

        .contact-form__textarea {
          min-height: rem(150px);

          textarea {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            @include ngMq($nbp--tablet, up) {
              border-left: 0;
            }
          }
        }

        /*
          Specific Form Fields
        */

        [data-field="contact__name"] {
          grid-row: 1 / span 1;
          // media query props
          grid-column: 1 / -1;

          @include ngMq($nbp--tablet, up) {
            grid-column: 1 / span 5;
          }
        }

        [data-field="contact__company"] {
          grid-row: 2 / span 1;
          // media query props
          grid-column: 1 / -1;

          @include ngMq($nbp--tablet, up) {
            grid-column: 1 / span 5;
          }
        }

        [data-field="contact__email"] {
          grid-row: 3 / span 1;
          // media query props
          grid-column: 1 / -1;

          @include ngMq($nbp--tablet, up) {
            grid-column: 1 / span 5;
            border-bottom: 1px solid black;
          }
        }

        [data-field="contact__message"] {
          grid-row: 4 / span 1;
          // media query props
          grid-column: 1 / -1;

          @include ngMq($nbp--tablet, up) {
            grid-row: 1 / span 3;
            grid-column: 6 / span 7;
          }
        }
      }
    } // form-container

    /*
      Form submit feedback
    */

    .form-post__success-indicator {
      color: $color--primary-highlight;
      font-size: 1.6rem;
      line-height: 1.4;
    }

    /*.form-post--success {
      display: block;
    }

    &[data-status="success"] {
      .form-post--success {
        display: block;
      }

      form {
        display: none;
      }
    }

    .form-post--error {
      display: none;
    }

    &[data-status="error"] {
      .form-post--error {
        display: block;
      }

      form {
        display: none;
      }
    }*/
  } 
}
</style>



// WEBPACK FOOTER //
// src/modules/contact/ContactUsForm.vue